import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// actions
import { ordersApiResponseSuccess, ordersApiResponseError } from "./actions";

// constants
import { OrdersActionTypes } from "./constants";
import {
  getOrdersApi,
  getOrdersRevenueApi,
  getOrdersRevenueUsdApi,
} from "../../helpers/api/orders";

function* getOrderss({ payload: { filter, status } }: any): SagaIterator {
  try {
    const response = yield call(getOrdersApi, filter, status);
    const orders = response?.data?.orders;

    yield put(ordersApiResponseSuccess(OrdersActionTypes.GET_ORDERS, orders));
  } catch (error: any) {
    yield put(ordersApiResponseError(OrdersActionTypes.GET_ORDERS, error));
  }
}

function* getOrderssRevenue({
  payload: { type, from, to, pathname },
}: any): SagaIterator {
  try {
    let response;
    let orders;

    if (pathname == "/revenue_usd") {
      response = yield call(getOrdersRevenueUsdApi);
      orders = response?.data?.formattedOrders;
    } else {
      response = yield call(getOrdersRevenueApi, type, from, to);
      orders = response?.data?.formattedOrders;
    }

    yield put(
      ordersApiResponseSuccess(OrdersActionTypes.GET_ORDERS_REVENUE, orders)
    );
  } catch (error: any) {
    yield put(
      ordersApiResponseError(OrdersActionTypes.GET_ORDERS_REVENUE, error)
    );
  }
}

export function* watchGetOrders() {
  yield takeEvery(OrdersActionTypes.GET_ORDERS, getOrderss);
}

export function* watchGetOrdersRevenue() {
  yield takeEvery(OrdersActionTypes.GET_ORDERS_REVENUE, getOrderssRevenue);
}

function* OrderSaga() {
  yield all([fork(watchGetOrders), fork(watchGetOrdersRevenue)]);
}

export default OrderSaga;
